// src/app/services/image-preload.service.ts
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ImagePreloadService {
    private imageCache: Map<string, HTMLImageElement> = new Map();

    preloadImages(imageUrls: string[]): Promise<void[]> {
        const preloadPromises = imageUrls.map(url => this.preloadImage(url));
        return Promise.all(preloadPromises);
    }

    private preloadImage(url: string): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.imageCache.has(url)) {
                resolve();
                return;
            }

            const img = new Image();
            img.src = url;
            img.onload = () => {
                this.imageCache.set(url, img);
                resolve();
            };
            img.onerror = () => {
                console.error(`Failed to preload image: ${url}`);
                reject();
            };
        });
    }

    isImageCached(url: string): boolean {
        return this.imageCache.has(url);
    }
}